/* ============================================================
   Bigly Brothers cart drawer — custom layer (Sep 2026)
   Discount codes, undo-after-remove, delivery estimate,
   one-tap upsell, returns modal, chat-widget dodge.
   Additive only: Dawn's own cart-drawer.js keeps handling
   open/close, focus trap, and quantity changes.
   ============================================================ */
(function () {
  'use strict';

  var DISCOUNT_ERROR = "That code didn't work. Check the code and try again.";

  var pendingCode = '';
  var appliedCodes = [];
  var discountWasOpen = false;

  // Remember successfully-applied codes across page loads, so re-entering
  // one (e.g. from a persisted cart session) reports "already applied"
  // instead of a generic invalid-code error.
  try {
    appliedCodes = JSON.parse(localStorage.getItem('bb_applied_codes') || '[]');
    if (!Array.isArray(appliedCodes)) appliedCodes = [];
  } catch (e) { appliedCodes = []; }

  function rememberAppliedCode(code) {
    code = (code || '').toUpperCase();
    if (code && appliedCodes.indexOf(code) === -1) appliedCodes.push(code);
    try { localStorage.setItem('bb_applied_codes', JSON.stringify(appliedCodes)); } catch (e) {}
  }
  var lastRemoved = null;
  var undoTimer = null;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* ---------- Delivery estimate: 3–5 business days, weekends excluded ---------- */
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) n--;
    }
    return d;
  }

  function fmtDate(d) {
    return DAYS[d.getDay()] + ', ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
  }

  function updateDelivery() {
    var now = new Date();
    var from = addBusinessDays(now, 3);
    var to = addBusinessDays(now, 5);
    var key = fmtDate(from) + '|' + fmtDate(to);
    $all('[data-bb-delivery]').forEach(function (el) {
      if (el.getAttribute('data-bb-key') === key) return; // idempotent: no render loop
      el.setAttribute('data-bb-key', key);
      el.innerHTML =
        '<svg class="bb-delivery__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
        '<path fill="currentColor" d="M3 6h11a1 1 0 0 1 1 1v8H4a1 1 0 0 1-1-1V6zm12 3h4l3 3v3h-7v-6zM7.5 18a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6zm10 0a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6z"/></svg>' +
        '<span><strong>Arrives ' + fmtDate(from) + ' – ' + fmtDate(to) + '</strong> · ships from Vancouver, BC</span>';
    });
  }

  /* ---------- Drawer section refresh (mirrors Dawn's renderContents) ---------- */
  function sectionInner(html, selector) {
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var node = doc.querySelector(selector);
      return node ? node.innerHTML : '';
    } catch (e) {
      return '';
    }
  }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer,cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        // NOTE: the Sections API returns section HTML keyed at the top level
        // (data['cart-drawer']), NOT under data.sections.
        var drawerHtml = sectionInner(data['cart-drawer'], '#CartDrawer');
        var drawerEl = document.getElementById('CartDrawer');
        if (drawerHtml && drawerEl) drawerEl.innerHTML = drawerHtml;
        var bubbleHtml = sectionInner(data['cart-icon-bubble'], '.shopify-section');
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubbleHtml && bubble) bubble.innerHTML = bubbleHtml;
        afterRender();
      })
      .catch(function () {
        /* stay on the current state — the drawer remains usable */
      });
  }

  /* ---------- Discount code ---------- */
  function setMsg(el, text, kind) {
    if (!el) return;
    el.hidden = false;
    el.textContent = text;
    el.classList.toggle('bb-discount__msg--error', kind === 'error');
    el.classList.toggle('bb-discount__msg--ok', kind === 'ok');
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function applyDiscount(code, msgEl, btnEl) {
    code = (code || '').trim();
    if (!code) {
      setMsg(msgEl, DISCOUNT_ERROR, 'error');
      return;
    }
    if (appliedCodes.indexOf(code.toUpperCase()) !== -1) {
      setMsg(msgEl, 'That code is already applied.', 'ok');
      return;
    }
    if (btnEl) btnEl.disabled = true;
    var beforeDiscount = 0;
    getCart()
      .then(function (cart) {
        beforeDiscount = cart.total_discount || 0;
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });
      })
      .then(function () { return getCart(); })
      .then(function (cart) {
        var afterDiscount = cart.total_discount || 0;
        if (afterDiscount > beforeDiscount) {
          pendingCode = '';
          rememberAppliedCode(code);
          setMsg(msgEl, 'Code applied.', 'ok');
          refreshDrawer();
        } else {
          setMsg(msgEl, DISCOUNT_ERROR, 'error');
        }
      })
      .catch(function () {
        setMsg(msgEl, DISCOUNT_ERROR, 'error');
      })
      .then(function () {
        if (btnEl) btnEl.disabled = false;
      });
  }

  /* ---------- Undo after remove ---------- */
  function showUndoBar() {
    if (!lastRemoved) return;
    var bar = $('[data-bb-undo]');
    if (!bar) return;
    bar.hidden = false;
    if (undoTimer) clearTimeout(undoTimer);
    undoTimer = setTimeout(function () {
      hideUndoBar();
      lastRemoved = null;
    }, 5000);
  }

  function hideUndoBar() {
    var bar = $('[data-bb-undo]');
    if (bar) bar.hidden = true;
    if (undoTimer) {
      clearTimeout(undoTimer);
      undoTimer = null;
    }
  }

  function undoRemove() {
    if (!lastRemoved) return;
    var item = lastRemoved;
    lastRemoved = null;
    hideUndoBar();
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.id, quantity: item.qty })
    }).then(function () {
      refreshDrawer();
    });
  }

  /* ---------- One-tap upsell ---------- */
  function addUpsell(btn) {
    var origText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: btn.getAttribute('data-bb-upsell-add'), quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        refreshDrawer();
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = origText;
      });
  }

  /* ---------- Chat widget dodge: hide Shopify Inbox while drawer is open ---------- */
  function syncChat() {
    var drawer = $('cart-drawer');
    var chat = $('shopify-chat');
    if (!drawer || !chat) return;
    chat.style.display = drawer.classList.contains('active') ? 'none' : '';
  }

  /* ---------- After every render ---------- */
  function afterRender() {
    updateDelivery();

    var input = $('[data-bb-discount-input]');
    if (input && pendingCode) input.value = pendingCode;
    var details = $('[data-bb-discount-details]');
    if (details && discountWasOpen) details.setAttribute('open', '');

    var overlay = document.getElementById('CartDrawer-Overlay');
    var drawer = $('cart-drawer');
    if (overlay && drawer && !overlay.getAttribute('data-bb-bound')) {
      overlay.setAttribute('data-bb-bound', '1');
      overlay.addEventListener('click', function () {
        drawer.close();
      });
    }

    showUndoBar(); // no-op unless a remove just happened
    syncChat();
  }

  /* ---------- Event wiring (delegated — survives Dawn's re-renders) ---------- */

  // Capture remove intent BEFORE Dawn processes it (capture phase).
  document.addEventListener(
    'click',
    function (e) {
      var rm = e.target.closest ? e.target.closest('cart-remove-button') : null;
      if (rm) {
        var row = rm.closest('.cart-item');
        var input = row ? row.querySelector('[data-quantity-variant-id]') : null;
        if (input) {
          lastRemoved = {
            id: input.getAttribute('data-quantity-variant-id'),
            qty: parseInt(input.value, 10) || 1
          };
        }
      }
    },
    true
  );

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;

    var upsellBtn = t.closest('[data-bb-upsell-add]');
    if (upsellBtn) {
      addUpsell(upsellBtn);
      return;
    }

    var applyBtn = t.closest('[data-bb-discount-apply]');
    if (applyBtn) {
      var wrap = applyBtn.closest('[data-bb-discount]');
      applyDiscount(
        wrap ? $('[data-bb-discount-input]', wrap).value : '',
        wrap ? $('[data-bb-discount-msg]', wrap) : null,
        applyBtn
      );
      return;
    }

    if (t.closest('[data-bb-undo-btn]')) {
      undoRemove();
      return;
    }

    if (t.closest('[data-bb-returns-open]')) {
      var modal = $('[data-bb-returns-modal]');
      if (modal && modal.showModal) modal.showModal();
      return;
    }
    if (t.closest('[data-bb-returns-close]')) {
      var modal2 = $('[data-bb-returns-modal]');
      if (modal2) modal2.close();
      return;
    }
    var modalBg = t.closest('[data-bb-returns-modal]');
    if (modalBg && t === modalBg) {
      modalBg.close();
      return;
    }

    var closer = t.closest('[data-bb-close]');
    if (closer) {
      var drawer = closer.closest('cart-drawer');
      if (drawer && drawer.close) drawer.close();
      return;
    }
  });

  // Enter key applies the discount code.
  document.addEventListener('keydown', function (e) {
    if (
      e.key === 'Enter' &&
      e.target.matches &&
      e.target.matches('[data-bb-discount-input]')
    ) {
      e.preventDefault();
      var wrap = e.target.closest('[data-bb-discount]');
      var btn = wrap ? $('[data-bb-discount-apply]', wrap) : null;
      if (btn) btn.click();
    }
  });

  // Preserve discount UI state across Dawn's re-renders.
  document.addEventListener('input', function (e) {
    if (e.target.matches && e.target.matches('[data-bb-discount-input]')) {
      pendingCode = e.target.value;
    }
  });
  document.addEventListener(
    'toggle',
    function (e) {
      if (e.target.matches && e.target.matches('[data-bb-discount-details]')) {
        discountWasOpen = e.target.open;
      }
    },
    true
  );

  /* ---------- Init ---------- */
  function init() {
    afterRender();

    var cartDrawerInner = document.getElementById('CartDrawer');
    if (cartDrawerInner) {
      new MutationObserver(function () {
        afterRender();
      }).observe(cartDrawerInner, { childList: true, subtree: true });
    }

    var drawer = $('cart-drawer');
    if (drawer) {
      new MutationObserver(syncChat).observe(drawer, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
